import { api } from "@/lib/api";


const installationPath = (installationId, suffix = "") =>
  `/gmao/installations/${encodeURIComponent(installationId)}${suffix}`;


export const getOptions = () =>
  api
    .get("/gmao/installations/workflow/options")
    .then((response) => response.data);


export const savePreparationDraft = (
  installationId,
  payload
) =>
  api
    .patch(
      installationPath(
        installationId,
        "/preparation-draft"
      ),
      payload
    )
    .then((response) => response.data);


export const registerDeliveryShare = (
  installationId,
  shareId
) =>
  api
    .post(
      installationPath(
        installationId,
        "/delivery-share"
      ),
      { share_id: shareId }
    )
    .then((response) => response.data);


export const acceptClientReschedule = (
  installationId,
  payload = {}
) =>
  api
    .post(
      installationPath(
        installationId,
        "/delivery-reschedule"
      ),
      payload
    )
    .then((response) => response.data);


export const startAfterConfirmation = (
  installationId
) =>
  api
    .post(
      installationPath(
        installationId,
        "/start-after-confirmation"
      )
    )
    .then((response) => response.data);


export const recordClientDecision = (
  installationId,
  payload
) =>
  api
    .post(
      installationPath(
        installationId,
        "/client-decision"
      ),
      payload
    )
    .then((response) => response.data);


export const returnToConfirmation = (installationId, reason) =>
  api.post(
    installationPath(installationId, "/return-to-confirmation"),
    { reason }
  ).then((response) => response.data);


export const returnToPlanning = (installationId, reason) =>
  api.post(
    installationPath(installationId, "/return-to-planning"),
    { reason }
  ).then((response) => response.data);


export const getArchiveDependencies = (
  installationId
) =>
  api
    .get(
      installationPath(
        installationId,
        "/archive-dependencies"
      )
    )
    .then((response) => response.data);


export const archiveInstallation = (
  installationId,
  payload
) =>
  api
    .post(
      installationPath(
        installationId,
        "/archive"
      ),
      payload
    )
    .then((response) => response.data);


export const fetchPublicDelivery = (token) =>
  api
    .get(
      `/public/shares/${encodeURIComponent(token)}/installation-delivery`
    )
    .then((response) => response.data);


export const respondPublicDelivery = (
  token,
  payload
) =>
  api
    .post(
      `/public/shares/${encodeURIComponent(token)}/installation-delivery/respond`,
      payload
    )
    .then((response) => response.data);
